__turbopack_context__.v({
  "placeholder": "o-teaser-grid-module-scss-module__K0LowG__placeholder",
  "section": "o-teaser-grid-module-scss-module__K0LowG__section",
  "section-cols-2": "o-teaser-grid-module-scss-module__K0LowG__section-cols-2",
  "section-cols-3": "o-teaser-grid-module-scss-module__K0LowG__section-cols-3",
  "section-masonry": "o-teaser-grid-module-scss-module__K0LowG__section-masonry",
  "section-pbd-3xl": "o-teaser-grid-module-scss-module__K0LowG__section-pbd-3xl",
  "section-pbd-3xs": "o-teaser-grid-module-scss-module__K0LowG__section-pbd-3xs",
  "section-pbd-l": "o-teaser-grid-module-scss-module__K0LowG__section-pbd-l",
  "section-pbd-m": "o-teaser-grid-module-scss-module__K0LowG__section-pbd-m",
  "section-pbd-none": "o-teaser-grid-module-scss-module__K0LowG__section-pbd-none",
  "section-pbd-s": "o-teaser-grid-module-scss-module__K0LowG__section-pbd-s",
  "section-pbd-xl": "o-teaser-grid-module-scss-module__K0LowG__section-pbd-xl",
  "section-pbd-xs": "o-teaser-grid-module-scss-module__K0LowG__section-pbd-xs",
  "section-pbd-xxl": "o-teaser-grid-module-scss-module__K0LowG__section-pbd-xxl",
  "section-pbd-xxs": "o-teaser-grid-module-scss-module__K0LowG__section-pbd-xxs",
  "section-pbm-3xl": "o-teaser-grid-module-scss-module__K0LowG__section-pbm-3xl",
  "section-pbm-3xs": "o-teaser-grid-module-scss-module__K0LowG__section-pbm-3xs",
  "section-pbm-l": "o-teaser-grid-module-scss-module__K0LowG__section-pbm-l",
  "section-pbm-m": "o-teaser-grid-module-scss-module__K0LowG__section-pbm-m",
  "section-pbm-none": "o-teaser-grid-module-scss-module__K0LowG__section-pbm-none",
  "section-pbm-s": "o-teaser-grid-module-scss-module__K0LowG__section-pbm-s",
  "section-pbm-xl": "o-teaser-grid-module-scss-module__K0LowG__section-pbm-xl",
  "section-pbm-xs": "o-teaser-grid-module-scss-module__K0LowG__section-pbm-xs",
  "section-pbm-xxl": "o-teaser-grid-module-scss-module__K0LowG__section-pbm-xxl",
  "section-pbm-xxs": "o-teaser-grid-module-scss-module__K0LowG__section-pbm-xxs",
  "section-ptd-3xl": "o-teaser-grid-module-scss-module__K0LowG__section-ptd-3xl",
  "section-ptd-3xs": "o-teaser-grid-module-scss-module__K0LowG__section-ptd-3xs",
  "section-ptd-l": "o-teaser-grid-module-scss-module__K0LowG__section-ptd-l",
  "section-ptd-m": "o-teaser-grid-module-scss-module__K0LowG__section-ptd-m",
  "section-ptd-none": "o-teaser-grid-module-scss-module__K0LowG__section-ptd-none",
  "section-ptd-s": "o-teaser-grid-module-scss-module__K0LowG__section-ptd-s",
  "section-ptd-xl": "o-teaser-grid-module-scss-module__K0LowG__section-ptd-xl",
  "section-ptd-xs": "o-teaser-grid-module-scss-module__K0LowG__section-ptd-xs",
  "section-ptd-xxl": "o-teaser-grid-module-scss-module__K0LowG__section-ptd-xxl",
  "section-ptd-xxs": "o-teaser-grid-module-scss-module__K0LowG__section-ptd-xxs",
  "section-ptm-3xl": "o-teaser-grid-module-scss-module__K0LowG__section-ptm-3xl",
  "section-ptm-3xs": "o-teaser-grid-module-scss-module__K0LowG__section-ptm-3xs",
  "section-ptm-l": "o-teaser-grid-module-scss-module__K0LowG__section-ptm-l",
  "section-ptm-m": "o-teaser-grid-module-scss-module__K0LowG__section-ptm-m",
  "section-ptm-none": "o-teaser-grid-module-scss-module__K0LowG__section-ptm-none",
  "section-ptm-s": "o-teaser-grid-module-scss-module__K0LowG__section-ptm-s",
  "section-ptm-xl": "o-teaser-grid-module-scss-module__K0LowG__section-ptm-xl",
  "section-ptm-xs": "o-teaser-grid-module-scss-module__K0LowG__section-ptm-xs",
  "section-ptm-xxl": "o-teaser-grid-module-scss-module__K0LowG__section-ptm-xxl",
  "section-ptm-xxs": "o-teaser-grid-module-scss-module__K0LowG__section-ptm-xxs",
  "text-intro": "o-teaser-grid-module-scss-module__K0LowG__text-intro",
});
